import ConfirmationBox from '@/components/confirmation-box.vue';

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.component('ConfirmationBox', ConfirmationBox);
});
